import React from 'react';
import { useNavigate } from 'react-router-dom';
import Marquee from 'react-fast-marquee';
import style from './indicator.module.css';
import feather from './assets/feather.png';

const FeatherIcon = () => (
  <img src={feather} alt="Peacock feather" className={style.icon} />
);

const Indicator = () => {
  const navigate = useNavigate();

  return (
    <div className={style.wrapper} onClick={() => navigate('/janmashtami2025')}>
      <Marquee gradient={false} speed={80}>
        {/* First message group */}
        <div className={style.messageGroup}>
          <FeatherIcon />
          <span className={style.text}>
            Looking forward to our next major festival? Don’t miss Janmashtami 2025 celebrations!
          </span>
          <FeatherIcon />
        </div>

        {/* Second message group */}
        <div className={style.messageGroup}>
          <FeatherIcon />
          <span className={style.text}>
            Celebrate with us – bhajans, prasadam & divine energy await you!
          </span>
          <FeatherIcon />
        </div>
      </Marquee>

    </div>
  );
};

export default Indicator;
